import axios from "axios";
import {
  AI_CHAT_CONFIG_ADMIN,
  AI_CHAT_CONFIG_USER,
} from "../Config/AIChatConfig";
import CryptoJS from "crypto-js";

const roleId = CryptoJS.AES.decrypt(
  localStorage.getItem("roleId") || "No-roleId",
  "Combis123"
).toString(CryptoJS.enc.Utf8);

const API_URL = AI_CHAT_CONFIG_ADMIN.apiUrl;
const assistentDocsUrl = API_URL + "/aitool/assistant/files";

const TENANT_ID =
  Number(roleId) < 4 ? AI_CHAT_CONFIG_ADMIN.tenantId : AI_CHAT_CONFIG_USER.tenantId;

const createMessage = async (data) => {
  console.log("user", localStorage.getItem("userId"));
  const formData = new FormData();

  if (data.chatId) formData.append("chatId", data.chatId);
  formData.append("message", data.message);

  return await axios
    .post(API_URL + "/aitool/assistant/chat/prompt", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Tenant-Id": TENANT_ID,
        "X-User-Id": localStorage.getItem("userId"),
      },
    })

    .then((res) => res.data)
    .catch((err) => err.response);
};

const getMessages = async (params) => {
  return axios
    .get(API_URL + "/aitool/assistant/chat/messages", {
      params,
      headers: {
        "X-Tenant-Id": TENANT_ID,
      },
    })
    .then((res) => res.data)
    .catch((err) => err.response);
};

async function getFiles({ page, pageSize, filterValues, configId }) {
  return await axios
    .get(`${assistentDocsUrl}`, {
      params: {
        page: page,
        take: pageSize,
        searchText: filterValues?.searchText,
        statusId: filterValues?.statusId,
      },
      headers: {
        "X-Tenant-Id": configId,
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function postFiles(data, tenantId) {
  console.log("form",data);
  const formData = new FormData();
  formData.append("formFile", data);

  

  const config = {
    headers: {
      "content-type": "multipart/form-data",
      "X-Tenant-Id": tenantId,
    },
  };
  return await axios
    .post(`${assistentDocsUrl}`, formData, config)
    .then((res) => res)
    .catch((err) => err.response);
}
function updateFiles(data) {
  return axios
    .put(`${assistentDocsUrl}/${data}/approve`, {
      headers: {
        "X-Tenant-Id": TENANT_ID,
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}
async function deleteFiles(data, tenantId) {
  return await axios
    .delete(`${assistentDocsUrl}/${data}`, {
      headers: {
        "content-type": "multipart/form-data",
        "X-Tenant-Id": tenantId,
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

export const AIAsisstentServices = {
  createMessage,
  getMessages,
  getFiles,
  postFiles,
  deleteFiles,
  updateFiles,
};
